import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { User } from '../../entities/user';
import { Language } from '../../entities/language';
import { LanguagesService } from '../../services/language.service';
import { UserService } from '../../services/user.service';

/**
 * Dialog data
 */
export interface DialogData {
  /**
   * User
   */
  userName: string;
}

/**
 * EditComponent
 */
@Component({
  selector: 'user-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})
export class EditComponent implements OnInit {
  /**
   * Hide
   */
  hide = true;

  /**
   * User
   */
  user: User;

  /**
   * Languages array
   */
  languages: Language[];

  /**
   * Is creating
   */
  isCreating: boolean;

  /**
   * User form
   */
  userForm: FormGroup;

  /**
   * Constructor
   *
   * @param dialogRef MatDialogRef
   * @param data DialogData
   * @param languagesService LanguagesService
   * @param userService UserService
   */
  constructor(
    public dialogRef: MatDialogRef<EditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private languagesService: LanguagesService,
    private userService: UserService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.userForm = new FormGroup({
      name: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      languageId: new FormControl(null),
    });

    if (this.data) {
      this.userService.get(this.data.userName).subscribe((user: User) => {
        this.user = user;
        for (const i in this.userForm.controls) {
          if (this.userForm.controls.hasOwnProperty(i)) {
            this.userForm.controls[i].setValue(this.user[i]);
          }
        }
      });
    } else {
      this.isCreating = true;
      this.user = new User();
    }

    this.languagesService.list().subscribe((languages: Language[]) => (this.languages = languages));
  }

  /**
   * Save user form
   */
  save(): void {
    const userBody = new User();
    for (const i in this.userForm.controls) {
      if (this.userForm.controls.hasOwnProperty(i)) {
        userBody[i] = this.userForm.controls[i].value;
      }
    }

    if (this.isCreating) {
      this.userService.create(userBody).subscribe(() => this.dialogRef.close({}));
    } else {
      this.userService.update(userBody).subscribe(() => this.dialogRef.close({}));
    }
  }

  /**
   * Close dialog
   */
  close(): void {
    this.dialogRef.close();
  }
}
